const initialState = {
  disconnectAttemptsUpgrade: 1,
  modalDisconnectionUpgrade: false,
  modalNoMatchFly: false,
  upgradeVoucherCheckIsActive: false,
};

const upgradeVoucher = (state = initialState, action) => {
  switch (action.type) {
    case 'CHANGE_VALUE_UPGRADE':
      return {
        ...state,
        upgradeVoucherCheckIsActive: action.value,
      };
    case 'DISCONNECT_ATTEMPTS_UPGRADE':
      return {
        ...state,
        disconnectAttemptsUpgrade: action.value,
      };
    case 'MODAL_DISCONNECTION_UPGRADE':
      return {
        ...state,
        modalDisconnectionUpgrade: action.value,
      };
    default:
      return state;
  }
};

export default upgradeVoucher;